import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { i18n } from 'i18n';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

const PREFIX = 'ModelDrawerTrigger';

const classes = {
  root: `${PREFIX}-root`,
  button: `${PREFIX}-button`,
};

const StyledBox = styled(Box)(() => ({
  [`&.${classes.root}`]: {
    float: 'right',
    right: 0,
  },

  [`& .${classes.button}`]: {
    borderRadius: 4,
    border: '1px solid rgba(255, 255, 255, 0.12)',
  },
}));

interface ModelDrawerTriggerProps {
  handleClick: () => void;
}

const ModelDrawerTrigger = ({ handleClick }: ModelDrawerTriggerProps) => (
  <StyledBox className={classes.root}>
    <Tooltip title={i18n._('Open Drawer')} enterDelay={500}>
      <IconButton
        className={classes.button}
        color="default"
        aria-label="close stope navigation"
        onClick={handleClick}
        size="large"
      >
        <MenuOpenIcon />
      </IconButton>
    </Tooltip>
  </StyledBox>
);

export default ModelDrawerTrigger;
